import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  isDark: true,
  colors: {
    primary: '#080808',
    primaryText: '#F1F1F1',
    gray: '#D7D7D8',
    lightGray: '#000000',
    lightlyGray: '#202020',
    white: '#101010',
    lightBlack: '#F1F1F1',
    black: '#FFFFFF',
    neutral: '#030303',
    danger: '#DD1B1B',
    success: '#05CD99',
    info: '#6488EA',
    successBg: '#05CD991A',
  },
  breakpoints: {
    sm: '0px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  borderRadius: '8px',
  inputHeight: '50px',
  inputHorizontalPadding: '12px',
};

export default theme;
